export const DOWNLOAD_TICKETS = 'DOWNLOAD_TICKETS'

export const downloadTickets = () => ({type: DOWNLOAD_TICKETS})
